
import { mapGetters , mapState, mapActions} from 'vuex'

import OpinionTable from './OpinionTable'
import HistoryChart from '~/components/Company/Analysis/StockHistory/HistoryChart'
import TwoRow from '~/components/Common/Layout/Table/TwoRow'
import TwoRow2 from '~/components/Common/Layout/Table/TwoRow2'

export default {
    components: { HistoryChart, TwoRow, OpinionTable, TwoRow2 },

    computed: {
        ...mapGetters('search', ['GETTER_HISTORY', 'GETTER_PRICELIST']),

        // 20230524 종목히스토리 수정
        ...mapState('search', ['corp']),
        corpOutline() {
            return this.corp
        },
    },
    data() {
        return {
            closeChartBox: true,
            loadingStatus : false,
            isChartOpened : false,
        }
    },

    // 20230524 종목히스토리 수정
    methods: {
        ...mapActions('search', [
            'GET_CORP_INFO',
            'GET_HISTORY_INFO',
            'GET_THEME_INFO',
            'GET_CORP_PRICE',
            'GET_LUMIT_INFO', // LIMIT 추가
        ]),
        openChart(){
            if(!this.isChartOpened){
            const code = this.corp.code
                if(code){
                    this.loadingStatus = true
                    this.GET_HISTORY_INFO(code)
                    .then(()=> {
                        console.log('121212')
                        this.loadingStatus = false
                        this.isChartOpened = true
                    })
                }
            }
        },
    },
    watch: {
        "corp.code"(newCode, oldCode){
            if (newCode !== oldCode) {
                this.isChartOpened = false
            }
        }
    }
}
